import cookie from '@/module/utils/cookie'
import { domain } from '@/module/constant'
import { resetAnalytics } from '@/plugins/sdk'

let login = function () {
  window.location.href = `${domain.SSO}/login/?next=${encodeURIComponent(window.location.href)}`
}

let logout = function (backUrl) {
  // 跳转前清理已识别身份，避免同一浏览器切换账号后事件串到前一个用户。
  try {
    resetAnalytics()
  } catch (e) {
    // 埋点异常不能阻断用户退出。
  }
  cookie.remove('token')
  window.location.href =
    `${domain.SSO}/logout/?next=` +
    encodeURIComponent(`${domain.SSO}/login/?next=${backUrl || window.location.href}`)
}

let signup = function (backUrl) {
  window.location.href = `${domain.SSO}/signup/?next=${encodeURIComponent(
    backUrl || window.location.href
  )}`
}

export { login, logout, signup }
